import { cva, type VariantProps } from 'class-variance-authority';

export { default as Alert } from './Alert.vue';

export const alertVariants = cva('flex items-center gap-2 rounded-md border p-2.5 text-xs', {
    variants: {
        variant: {
            warning: 'text-warning border-warning bg-warning/5',
            error: 'text-destructive border-destructive bg-destructive/5',
            success: 'text-success border-success bg-success/5',
            info: 'text-foreground border-border bg-background',
        },
    },
    defaultVariants: {
        variant: 'warning',
    },
});

export type AlertVariants = VariantProps<typeof alertVariants>;
